export const DARK_WARNING_TEXT_COLOR = '#7C2D12';
export const DARK_WARNING_BORDER_COLOR = '#C2410C';

export const DARK_WARNING_CHIP_SX = {
  color: DARK_WARNING_TEXT_COLOR,
  borderColor: DARK_WARNING_BORDER_COLOR,
  fontWeight: 700,
  '& .MuiChip-label': {
    color: 'inherit',
  },
};

export const getWarningChipSx = (color, variant = 'outlined') =>
  color === 'warning' && variant === 'outlined' ? DARK_WARNING_CHIP_SX : undefined;
